import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

/** Default text values — used as fallback when no DB value exists. */
export const DEFAULT_CONTENT = {
  // Home
  "home.hero.eyebrow": "Grup industrial · Peste 20 ani de expertiză",
  "home.hero.title_1": "Soluții integrate.",
  "home.hero.title_2": "Achiziții și dotări",
  "home.hero.title_3": "industriale.",
  "home.hero.description":
    "Un grup de firme specializate în achiziții pentru proiecte europene, digitalizare și producție. Facilităm accesul la tehnologie de vârf cu livrare în toată România. Un singur partener pentru toate categoriile de echipamente, indiferent de domeniul de activitate.",
  "home.hero.cta_primary": "Solicită consultanță",
  "home.hero.cta_secondary": "Explorează departamentele",
  "home.hero.image_url":
    "https://images.unsplash.com/photo-1715156153744-d5fd2f1f66eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzcyUyMGJ1aWxkaW5nfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc4MzE0NTU4OXww&ixlib=rb-4.1.0&q=85",
  "home.eu.title_1": "Partenerul tău expert în proiecte cu",
  "home.eu.title_2": "fonduri europene.",
  "home.eu.description":
    "Ai câștigat o finanțare? Eliminăm stresul achizițiilor. Gestionăm întregul flux: de la identificarea echipamentelor conforme și negocierea cu furnizorii externi, până la logistica livrării și întocmirea dosarului de decontare.",
  "home.eu.stat1_num": "300+",
  "home.eu.stat1_label": "Proiecte de achiziții implementate cu succes în România",
  "home.eu.stat2_num": "100%",
  "home.eu.stat2_label": "Conformitate cu cerințele ghidului solicitantului",
  "home.cta.title_1": "Ai un proiect?",
  "home.cta.title_2": "Vorbește",
  "home.cta.title_3": "cu noi.",

  // About
  "about.hero.title_1": "Un grup.",
  "about.hero.title_2": "Nouă",
  "about.hero.title_3": "capabilități.",
  "about.who.heading": "Peste 20 ani de expertiză industrială",
  "about.who.p1":
    "SUNTEC GROUP este un grup de firme specializate în achiziții pentru proiecte europene, digitalizare și producție. Facilităm accesul la tehnologie de vârf cu livrare în toată România, cu peste 300 de proiecte de achiziții implementate cu succes.",
  "about.who.p2":
    "Un singur partener pentru toate categoriile de echipamente, indiferent de domeniul de activitate. Fiecare divizie funcționează cu autonomie operațională, dar comunică între ele pentru a livra proiecte end-to-end — de la consultanță și proiectare, până la instalare, punere în funcțiune și dosar de decontare.",

  // Contact
  "contact.hero.title_1": "Hai să stăm",
  "contact.hero.title_2": "de vorbă.",
  "contact.sales.email": "sales@suntec.ro",
  "contact.sales.phone1": "+40 746 111 531",
  "contact.sales.phone2": "+40 741 111 887",
  "contact.service.email": "service@suntec.ro",
  "contact.service.phone1": "+40 741 111 887",
  "contact.accounting.email": "contabilitate@suntec.ro",
  "contact.accounting.phone1": "+40 746 111 529",
  "contact.address1_title": "Suntec SRL / Suntec Solutions SRL",
  "contact.address1": "Str. Izvorului, nr. 22 · 410176 Oradea",
  "contact.address2_title": "Suntec Outlet SRL",
  "contact.address2": "Str. Avântului, nr. 15 · 410520 Oradea",
  "contact.address3_title": "Suntec Trade SRL",
  "contact.address3": "Sat Cheriu, nr. 72 · 417362 Bihor",
  "contact.hours": "L–V · 09:00–18:00",

  // Footer
  "footer.tagline":
    "Soluții integrate pentru achiziții și dotări industriale. Grup industrial cu 9 direcții de activitate — peste 20 ani de expertiză.",
  "footer.address": "Oradea · Bihor, România",
  "footer.copyright_right": "ROMÂNIA / EU",

  // Buttons — labels + links (link accepts internal path or full URL)
  // Navbar
  "btn.nav.cta.label": "Solicită ofertă →",
  "btn.nav.cta.link": "/contact",
  // Home hero
  "btn.home.hero.primary.label": "Solicită consultanță",
  "btn.home.hero.primary.link": "/contact",
  "btn.home.hero.secondary.label": "Explorează departamentele",
  "btn.home.hero.secondary.link": "/departamente",
  // Home EU section
  "btn.home.eu.label": "Detalii proiecte europene",
  "btn.home.eu.link": "/departamente/proiecte-europene",
  // Home departments header link
  "btn.home.departments_all.label": "Toate departamentele →",
  "btn.home.departments_all.link": "/departamente",
  // Home CTA section
  "btn.home.cta.label": "Solicită ofertă",
  "btn.home.cta.link": "/contact",
  // About page CTA
  "btn.about.cta.label": "Solicită consultanță",
  "btn.about.cta.link": "/contact",
  // Department detail CTA
  "btn.dept.cta.label": "Solicită consultanță",
  "btn.dept.cta.link": "/contact",
  // Blog article CTA
  "btn.blog.article.cta.label": "Ai un proiect similar? Contactează-ne",
  "btn.blog.article.cta.link": "/contact",
  // Contact form submit
  "btn.contact.submit.label": "Trimite mesajul",

  // Section titles — editable headings across pages
  "section.home.eu.eyebrow": "Proiecte europene",
  "section.home.departments.eyebrow": "02 / Domeniile noastre de activitate",
  "section.home.departments.title_1": "divizii",
  "section.home.departments.title_2": "operaționale",
  "section.home.cta.eyebrow": "03 / Următorul pas",
  // Departments list page
  "section.departments.hero.eyebrow": "Departamente",
  "section.departments.hero.title_1": "divizii,",
  "section.departments.hero.title_2": "o singură livrare.",
  // About page
  "section.about.hero.eyebrow": "Despre",
  "section.about.who.eyebrow": "Cine suntem",
  "section.about.legal.eyebrow": "Structură legală · Date fiscale",
  "section.about.legal.title": "Patru companii, un singur grup.",
  "section.about.cta.eyebrow": "Contactează echipa",
  "section.about.cta.title": "Hai să discutăm proiectul tău.",
  // Contact page
  "section.contact.hero.eyebrow": "Contact",
  "section.contact.depts.eyebrow": "Contact direct pe departamente",
  "section.contact.offices.eyebrow": "Sedii",
  // Blog list
  "section.blog.hero.eyebrow": "Blog · Știri",
  "section.blog.hero.title_1": "Notițe",
  "section.blog.hero.title_2": "de la",
  "section.blog.hero.title_3": "teren.",
  // Department detail
  "section.dept.manifest.eyebrow": "02 / Manifest",
  "section.dept.manifest.title_1": "Ce facem",
  "section.dept.manifest.title_2": "exact.",
  "section.dept.services.eyebrow": "Servicii",
  "section.dept.highlights.eyebrow": "03 / Capacități",
  "section.dept.gallery.eyebrow": "04 / Portofoliu",
  "section.dept.gallery.title_1": "Galerie",
  "section.dept.gallery.title_2": "proiecte.",
  "section.dept.programs.eyebrow": "Experiență în programe europene",
  "section.dept.programs.title_1": "Fonduri UE",
  "section.dept.programs.title_2": "accesate.",
  "section.dept.references.eyebrow": "Proiecte de referință",
  "section.dept.references.title": "Referințe.",
  "section.dept.domains.eyebrow": "Domenii de experiență",
  "section.dept.values.eyebrow": "Valori",
  "section.dept.cta.eyebrow": "Următorul pas",

  // Page slugs (editable via CMS — used to build all internal URLs)
  "page.about.slug": "despre",
  "page.contact.slug": "contact",
  "page.blog.slug": "blog",
  "page.departments.slug": "departamente",

  // Repeatable arrays (stored as JSON strings, edited via CMS Repetabile tab)
  "contact.groups": JSON.stringify([
    { label: "Vânzări",       email: "sales@suntec.ro",         phones: "+40 746 111 531, +40 741 111 887" },
    { label: "Service",       email: "service@suntec.ro",       phones: "+40 741 111 887" },
    { label: "Contabilitate", email: "contabilitate@suntec.ro", phones: "+40 746 111 529" },
  ]),
  "contact.offices": JSON.stringify([
    { title: "Sediu Oradea",   address: "Str. Izvorului, nr. 22, 410176, Oradea, România" },
    { title: "Sediu Marghita", address: "Str. Republicii, nr. 88, Marghita, Bihor, România" },
    { title: "Sediu Aleșd",    address: "Șos. Aleșd–Cheriu, DN1 km 62, Bihor, România" },
  ]),
  "about.entities": JSON.stringify([
    { name: "Suntec Trade SRL",    cui: "RO 18442684", reg: "J05/426/2006",  capital: "400.000 RON", iban: "RO71RNCB0032106153860003 · BCR", address: "Sat Cheriu, nr. 72, Bihor, 417362, România" },
    { name: "Suntec SRL",          cui: "16106440",    reg: "J15/142/2004",  capital: "200 RON",     iban: "RO77RNCB0032161090770001 · BCR", address: "Str. Izvorului, nr. 22, 410176, Oradea, România" },
    { name: "Suntec Outlet SRL",   cui: "33163586",    reg: "J05/784/2014",  capital: "200 RON",     iban: "RO20RNCB0032177934020001 · BCR", address: "Str. Avântului, nr. 15, 410520, Oradea, România" },
    { name: "Suntec Solutions SRL",cui: "50314875",    reg: "J05/1730/2024", capital: "200 RON",     iban: "RO39RNCB0032179316860001 · BCR", address: "Str. Izvorului, nr. 22, 410176, Oradea, România" },
  ]),
  "home.stats": JSON.stringify([
    { k: "300+", v: "Proiecte de achiziții implementate în România" },
    { k: "100%", v: "Conformitate cu cerințele finanțatorilor" },
    { k: "09",   v: "Domenii integrate de activitate" },
    { k: "20+",  v: "Ani de experiență" },
  ]),

  // Analytics & cookie consent
  "analytics.ga_measurement_id": "G-R9VV8ZC50G",
  "analytics.enabled": "yes",
  "cookie.banner.title": "Folosim cookie-uri",
  "cookie.banner.text": "Folosim cookie-uri de analytics (Google Analytics 4) pentru a înțelege cum este utilizat site-ul și a-l îmbunătăți. Poți accepta sau refuza — alegerea ta se salvează local.",
  "cookie.banner.accept": "Accept",
  "cookie.banner.decline": "Refuz",
};

export const DEFAULT_THEME = {
  colors: {
    background: "#FFFFFF",
    foreground: "#0A0A0A",
    muted: "#F4F4F5",
    border: "#E4E4E7",
    grey: "#71717A",
  },
  fonts: {
    heading: "Chivo",
    body: "IBM Plex Sans",
    mono: "IBM Plex Mono",
  },
};

/** Available font choices */
export const FONT_CHOICES = {
  heading: [
    "Inter",
    "Chivo",
    "IBM Plex Sans",
    "Playfair Display",
    "Space Grotesk",
    "Manrope",
    "Bodoni Moda",
    "Cormorant Garamond",
    "Anton",
    "Archivo Black",
  ],
  body: [
    "Inter",
    "IBM Plex Sans",
    "Work Sans",
    "Karla",
    "Manrope",
    "Figtree",
    "Merriweather",
  ],
  mono: ["Inter", "IBM Plex Mono", "Space Mono", "JetBrains Mono", "Roboto Mono", "Fira Code"],
};

function buildGoogleFontsUrl(fonts) {
  const list = [];
  const WGHTS = "wght@300;400;500;600;700;800;900";
  if (fonts.heading) list.push(`${fonts.heading.replace(/ /g, "+")}:${WGHTS}`);
  if (fonts.body && fonts.body !== fonts.heading)
    list.push(`${fonts.body.replace(/ /g, "+")}:${WGHTS}`);
  if (fonts.mono && fonts.mono !== fonts.heading && fonts.mono !== fonts.body)
    list.push(`${fonts.mono.replace(/ /g, "+")}:wght@400;500;600`);
  return `https://fonts.googleapis.com/css2?${list.map((f) => `family=${f}`).join("&")}&display=swap`;
}

function injectGoogleFonts(fonts) {
  const url = buildGoogleFontsUrl(fonts);
  let link = document.getElementById("gfont-dynamic");
  if (!link) {
    link = document.createElement("link");
    link.id = "gfont-dynamic";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  if (link.href !== url) link.href = url;
}

function applyTheme(theme) {
  const colors = { ...DEFAULT_THEME.colors, ...(theme.colors || {}) };
  const fonts = { ...DEFAULT_THEME.fonts, ...(theme.fonts || {}) };

  const root = document.documentElement;
  root.style.setProperty("--st-bg", colors.background);
  root.style.setProperty("--st-fg", colors.foreground);
  root.style.setProperty("--st-muted", colors.muted);
  root.style.setProperty("--st-border", colors.border);
  root.style.setProperty("--st-grey", colors.grey);
  root.style.setProperty("--st-font-heading", `'${fonts.heading}', system-ui, sans-serif`);
  root.style.setProperty("--st-font-body", `'${fonts.body}', system-ui, sans-serif`);
  root.style.setProperty("--st-font-mono", `'${fonts.mono}', ui-monospace, monospace`);

  injectGoogleFonts(fonts);
}

export function SiteProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [theme, setTheme] = useState(DEFAULT_THEME);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const [c, t] = await Promise.all([
        api.get("/site/content"),
        api.get("/site/theme"),
      ]);
      // Merge with defaults: DB overrides only where set
      const merged = { ...DEFAULT_CONTENT, ...c.data };
      setContent(merged);
      const themeMerged = {
        colors: { ...DEFAULT_THEME.colors, ...(t.data?.colors || {}) },
        fonts: { ...DEFAULT_THEME.fonts, ...(t.data?.fonts || {}) },
      };
      setTheme(themeMerged);
      applyTheme(themeMerged);
    } catch (e) {
      applyTheme(DEFAULT_THEME);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const t = (key, fallback) => content[key] ?? fallback ?? DEFAULT_CONTENT[key] ?? "";

  /** Parse a CMS value stored as JSON array (repeatable rows). */
  const list = (key, fallback = []) => {
    const raw = content[key] ?? DEFAULT_CONTENT[key];
    if (!raw) return fallback;
    if (Array.isArray(raw)) return raw;
    try {
      const v = JSON.parse(raw);
      return Array.isArray(v) ? v : fallback;
    } catch {
      return fallback;
    }
  };

  // Sanitise a slug: no leading slash, lowercase, kebab-case-safe.
  const cleanSlug = (s) => (s || "").toString().trim().replace(/^\/+|\/+$/g, "").replace(/\s+/g, "-").toLowerCase();

  // Resolved page URLs — used across the app. Reads from CMS with defaults.
  const urls = {
    about: `/${cleanSlug(t("page.about.slug", "despre"))}`,
    contact: `/${cleanSlug(t("page.contact.slug", "contact"))}`,
    blog: `/${cleanSlug(t("page.blog.slug", "blog"))}`,
    departments: `/${cleanSlug(t("page.departments.slug", "departamente"))}`,
  };
  // Helpers for child routes so callers don't have to concatenate.
  const dept = (slug) => `${urls.departments}/${slug}`;
  const article = (slug) => `${urls.blog}/${slug}`;

  return (
    <SiteContext.Provider value={{ content, theme, loaded, t, list, refresh, urls, dept, article }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
/** Convenience — returns resolved URL builders. */
export const useUrl = () => {
  const { urls, dept, article } = useContext(SiteContext);
  return { ...urls, dept, article };
};
